module.exports = __webpack_public_path__ + "img/icon-copy.28456246.svg";